var React = require('react');

function Search (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M16.0001 15.2878L15.293 15.9949L21.2962 21.9982L22.0033 21.2911L16.0001 15.2878Z","stroke":"white","strokeOpacity":"0.6","strokeWidth":"1.2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z","fill":"white","fillOpacity":"0.3","stroke":"white","strokeOpacity":"0.6","strokeWidth":"1.2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Search.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Search;

Search.default = Search;
